import config from 'react-global-configuration';
import jwt from 'jsonwebtoken'
import apiEndpointPaths from '../../WidgetCompoentens/Shaakira/EcommerceDefault/helper/apiEndpointPaths';
import { APIError, errorLogger } from "./errorHandlers";
import axios from "axios";



const generateToken = () => {
    const timestamp = Math.floor(Date.now() / 1000) + 1000;
    let payload = {
        "aud": config.get('ProductjwtAud'),
        "exp": timestamp,
        "iss": config.get('ProductjwtIss')
    };

    let signOptions = {
        "algorithm": "RS256"
    };

    let privateKey = config.get('ProductprivateKey');
    let token = jwt.sign(payload, privateKey, signOptions);
    return token
}
export const getEcomProdCategories = async (orgID, catID, skip) => {
    if (orgID) {
        let token = generateToken();
        let settings = localStorage.getItem("ECOM_SETTINGS") && JSON.parse(localStorage.getItem("ECOM_SETTINGS")) || [];
        const salesLocID = settings.find((setting) => setting.OrgID === orgID) ? settings.find((setting) => setting.OrgID === orgID).SalesLocationID : ""
        if (token) {
            try {
                const apiReqUrl = `${apiEndpointPaths.productRegistry.getCategories}${orgID}/${salesLocID}/${catID}/${skip}/12`;
                let headers = {
                    Authorization: `Bearer ${token} `,
                    "Access-Control-Allow-Origin": "*",
                };
                const response = await axios({
                    method: "GET",
                    url: apiReqUrl,
                    headers,
                });
                const { Status } = response.data;

                return Status ? response.data : null;
            }
            catch (error) {
                let customErrMsg = error.customErrMsg || "";
                if (error.custmErrType === "APIERROR") {
                    switch (true) {
                        default: {
                            customErrMsg = "Error Occurred. Please try again.";
                            break;
                        }
                    }
                }
                error(error, { customErrMsg });
                return Promise.reject(APIError(customErrMsg, error));
            }

        }
    }
}
export const getEcomProdCategoriesCount = async (orgID, catID) => {
    if (orgID) {
        let token = generateToken();
        if (token) {
            try {
                const apiReqUrl = `${apiEndpointPaths.productRegistry.getCategoriesCount}${orgID}/${catID}`;
                let headers = {
                    Authorization: `Bearer ${token}`,
                    "Access-Control-Allow-Origin": "*",
                };
                const response = await axios({
                    method: "GET",
                    url: apiReqUrl,
                    headers,
                });
                const { Status, Result } = response.data;

                return Status ? Result : null;
            }
            catch (error) {
                let customErrMsg = error.customErrMsg || "";
                if (error.custmErrType === "APIERROR") {
                    switch (true) {
                        default: {
                            customErrMsg = "Error Occurred. Please try again.";
                            break;
                        }
                    }
                }
                error(error, { customErrMsg });
                return Promise.reject(APIError(customErrMsg, error));
            }

        }
    }
}
export const getAllEcomProdCategories = async (orgID) => {
    if (orgID) {
        let token = generateToken();
        if (token) {
            try {
                const apiReqUrl = `${apiEndpointPaths.productRegistry.getCategoriesList}${orgID}`;
                let headers = {
                    Authorization: `Bearer ${token}`,
                    "Access-Control-Allow-Origin": "*",
                };
                const response = await axios({
                    method: "GET",
                    url: apiReqUrl,
                    headers,
                });
                const { Status, Result } = response.data;

                return Status ? Result : null;
            }
            catch (error) {
                let customErrMsg = error.customErrMsg || "";
                if (error.custmErrType === "APIERROR") {
                    switch (true) {
                        default: {
                            customErrMsg = "Error Occurred. Please try again.";
                            break;
                        }
                    }
                }
                error(error, { customErrMsg });
                return Promise.reject(APIError(customErrMsg, error));
            }

        }
    }
}
export const getEcomProdFilterCategories = async (orgID, apiReqBody, skip) => {
    if (orgID) {
        let token = generateToken();
        let settings = localStorage.getItem("ECOM_SETTINGS") && JSON.parse(localStorage.getItem("ECOM_SETTINGS")) || [];
        const salesLocID = settings.find((setting) => setting.OrgID === orgID) ? settings.find((setting) => setting.OrgID === orgID).SalesLocationID : ""

        if (token) {
            try {

                const apiReqUrl = `${apiEndpointPaths.productRegistry.getFilteredList}/${orgID}/${salesLocID}/${skip}/12`;
                let headers = {
                    Authorization: `Bearer ${token}`,
                    "Access-Control-Allow-Origin": "*",
                };
                const response = await axios({
                    method: "POST",
                    url: apiReqUrl,
                    headers,
                    data: apiReqBody,

                });
                const { Status } = response.data;

                return Status ? response.data : null;
            }
            catch (error) {
                let customErrMsg = error.customErrMsg || "";
                if (error.custmErrType === "APIERROR") {
                    switch (true) {
                        default: {
                            customErrMsg = "Error Occurred. Please try again.";
                            break;
                        }
                    }
                }
                error(error, { customErrMsg });
                return Promise.reject(APIError(customErrMsg, error));
            }

        }
    }
}
export const getEcomProdFilterCategoriesCount = async (orgID, apiReqBody) => {
    if (orgID) {
        let token = generateToken();
        let settings = localStorage.getItem("ECOM_SETTINGS") && JSON.parse(localStorage.getItem("ECOM_SETTINGS")) || [];
        const salesLocID = settings.find((setting) => setting.OrgID === orgID) ? settings.find((setting) => setting.OrgID === orgID).SalesLocationID : ""
        if (token) {
            try {
                const apiReqUrl = `${apiEndpointPaths.productRegistry.getFilteredListCount}${orgID}/${salesLocID}`;
                let headers = {
                    Authorization: `Bearer ${token}`,
                    "Access-Control-Allow-Origin": "*",
                };
                const response = await axios({
                    method: "POST",
                    url: apiReqUrl,
                    data: apiReqBody,
                    headers,
                });
                const { Status, Result } = response.data;

                return Status ? Result : null;
            }
            catch (error) {
                let customErrMsg = error.customErrMsg || "";
                if (error.custmErrType === "APIERROR") {
                    switch (true) {
                        default: {
                            customErrMsg = "Error Occurred. Please try again.";
                            break;
                        }
                    }
                }
                error(error, { customErrMsg });
                return Promise.reject(APIError(customErrMsg, error));
            }

        }
    }
}
export const productsSearch = async (apiReqBody) => {
    let token = generateToken();
    if (token) {
        try {

            const apiReqUrl = `${apiEndpointPaths.productRegistry.searchProducts}`;
            let headers = {
                Authorization: `Bearer ${token}`,
                "Access-Control-Allow-Origin": "*",
            };
            const response = await axios({
                method: "POST",
                url: apiReqUrl,
                headers,
                data: apiReqBody,

            });
            const { Status, Result } = response.data;

            return Status ? Result : [];
        }
        catch (error) {
            let customErrMsg = error.customErrMsg || "";
            if (error.custmErrType === "APIERROR") {
                switch (true) {
                    default: {
                        customErrMsg = "Error Occurred. Please try again.";
                        break;
                    }
                }
            }
            error(error, { customErrMsg });
            return Promise.reject(APIError(customErrMsg, error));
        }

    }
}